import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ActiveCollectionsFilterCollection,
  CollectionCategories,
  CollectionsFilterInterface,
} from '../../interfaces/collections-filter.interface';
import { Subscription } from 'rxjs';
import { first, map, take } from 'rxjs/operators';
import {
  CollectCollectionsFilters,
  SelectCollectionsCategories,
  SelectLetter,
} from '../../store/actions/collections-filter.actions';
import { CollectionsService } from '../../service/collections.service';
import i18next from 'i18next';
import { CollectionInterface } from '../../interfaces/collection.interface';
import { DataService } from '../../../../core/services/data.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-collections-filter',
  templateUrl: './collections-filter.component.html',
  styleUrls: ['./collections-filter.component.scss'],
})
export class CollectionsFilterComponent implements OnInit {
  collectionData!: CollectionInterface[];
  collectionCategoriesSelected: CollectionCategories = {};
  characters!: NodeListOf<Element>;
  charactersActive: string[] = [];
  dataLoaded = this.collectionsService.dataLoaded;
  collectionFilterList!: any;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private store: Store<{ collectionsFilter: CollectionsFilterInterface }>,
    public collectionsService: CollectionsService,
    public dataService: DataService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.collectionsService.loadDataSub
      .pipe(
        take(1),
        map((item: any) => {
          this.serveData();
          this.getFirstLetters();
        })
      )
      .subscribe();
  }

  ngOnInit(): void {
    if (this.dataLoaded) {
      this.serveData();
      this.getFirstLetters();
    }
    this.characters = document.querySelectorAll('.character');

    const sub = this.store
      .select('collectionsFilter')
      .pipe(first())
      .subscribe((data) => {
        this.collectionCategoriesSelected = {
          ...data.tags.collectionCategories,
        };
        console.log(data);
        if (data.tags.alphabet.letter) {
          console.log(data.tags.alphabet.letter);
          this.setLetterActive(data.tags.alphabet.letter.toLowerCase());
        }
      });
    this.subscriptions.add(sub);
    /* const resetFilter = this.searchFilterService.resetFilters$.subscribe(() => {
      this.productSectionsSelected = {};
    });
    this.subscriptions.add(resetFilter);*/
    const params = this.activatedRoute.snapshot.queryParams;
    console.log(params);
    if (params.c) {
      const categories = params.c.split(',');
      for (let i = 0; i < categories.length; i++) {
        const category = categories[i];
        this.collectionCategoriesSelected[category] = false;
        if (category === 'gifts') {
          this.collectionCategoriesSelected.decoration =
            !this.collectionCategoriesSelected.decoration;
        }
        if (category === 'serving') {
          this.collectionCategoriesSelected.serving =
            !this.collectionCategoriesSelected.serving;
        }
      }
      this.store.dispatch(
        SelectCollectionsCategories(this.collectionCategoriesSelected)
      );
      this.collectFilters();
    }
    if (params.l) {
      this.store.dispatch(SelectLetter({ letter: params.l }));
    }
  }

  getFirstLetters(): void {
    if (this.collectionData) {
      for (let i = 0; i < this.collectionData.length; i++) {
        const item = this.collectionData[i];
        const text = i18next.t(item.texts.title);
        const currentCharcode: string = text[0].toUpperCase();
        this.charactersActive.push(currentCharcode);
      }
    }
    this.charactersActive = [...new Set(this.charactersActive)];
    // console.log(this.charactersActive);
  }

  handleCharacter(event: any, className: string, letter: string): void {
    const hasClass = event.target.classList.contains(className);
    if (!hasClass) {
      this.characters.forEach((item: Element) => {
        item.classList.remove(className);
      });
      // console.log(this.characters);
      event.target.classList.add(className);
      this.store.dispatch(SelectLetter({ letter }));
      void this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { l: letter },
        queryParamsHandling: 'merge',
      });
    } else {
      event.target.classList.remove(className);
      this.store.dispatch(SelectLetter({ letter: '' }));
      void this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { l: null },
        queryParamsHandling: 'merge',
      });
    }
    const sContainer = document.querySelector('.boxed > .collections-list');
    const sContainerM = document.querySelector('main.content');
    if (sContainer) {
      sContainer.scrollTop = 0;
    }
    if (sContainerM) {
      sContainerM.scrollTop = 0;
    }
  }

  setLetterActive(className: string): void {
    const elements = document.querySelectorAll('.character.' + className);
    console.log(elements);
    if (elements.length > 0) {
      elements.forEach((element) => {
        element.classList.add('active');
      });
    }
  }

  handleCollectionCategoriesSelected(
    collectionCategories: string,
    filterValue: string
  ): void {
    this.collectionCategoriesSelected[collectionCategories] =
      !this.collectionCategoriesSelected[collectionCategories];
    if (collectionCategories === 'gifts') {
      this.collectionCategoriesSelected.decoration =
        !this.collectionCategoriesSelected.decoration;
    }
    if (collectionCategories === 'serving') {
      this.collectionCategoriesSelected.serving =
        !this.collectionCategoriesSelected.serving;
    }
    this.store.dispatch(
      SelectCollectionsCategories(this.collectionCategoriesSelected)
    );
    this.collectFilters();
    const entries = Object.entries(this.collectionCategoriesSelected);
    // collectionCategoriesSelected ist true wenn sie in der suche drin sind
    const selected = entries.filter(([_, v]) => !v);
    void this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        c: selected.length === 0 ? null : selected.map(([k, _]) => k).join(','),
      },
      queryParamsHandling: 'merge',
    });
  }

  serveData(): void {
    // this.collectionData = Object.values(this.collectionsService.getCollections());
    this.collectionData = Object.values(
      this.collectionsService.collectionsData
    );
    this.collectionFilterList =
      this.dataService.filterList.collectionFilters.category_type.en;
    console.log(this.collectionFilterList);

  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  collectFilters(): void {
    const activeFilterCollection: ActiveCollectionsFilterCollection = {
      categories: [],
    };
    for (const categoriesKey in this.collectionCategoriesSelected) {
      if (!this.collectionCategoriesSelected[categoriesKey]) {
        if (categoriesKey === 'Gifts') {
          activeFilterCollection.categories.push(
            this.getKeyByValue('Decoration')
          );
        }
        if (categoriesKey === 'Baking') {
          activeFilterCollection.categories.push(this.getKeyByValue('Serving'));
        }
        activeFilterCollection.categories.push(
          this.getKeyByValue(categoriesKey)
        );
      }
    }
    this.store.dispatch(CollectCollectionsFilters(activeFilterCollection));
  }

  getKeyByValue(value: string): string {
    console.log(this.collectionFilterList);
    const indexOfF = Object.values(this.collectionFilterList).indexOf(value);
    console.log(value);
    console.log(Object.values(this.collectionFilterList).indexOf(value));

    return Object.keys(this.collectionFilterList)[indexOfF];
  }
}
